// if you plan to change these paths:
// 1. change them in the backend too
// 2. add redirect routes for backwards compatibility,
//    because the emails might haved aged a few days or weeks in email inboxes

import { environmentService } from '../../config/di/container';

//    before the users click on the links
const pathsUsedInEmailsToUsers = {
  ConfirmEmailViaLink: '/confirmEmailViaLink',
  ConfirmOffer: '/confirmOffer'
};

export const paths = {
  ...pathsUsedInEmailsToUsers,

  LandingPage: '/to-landingpage',

  ApartmentCount: '/apartment-count', // previously: /start/1
  ThermalMetering: '/thermal-metering', // previously: /start/2
  CentralHeating: '/central-heating', // previously: /start/3
  CentralHeatingMandatory: '/central-heating-mandatory', // previously: /start/4/fallback
  HotWaterDelivery: '/water-central-heating', // previously: /start/4
  HeatingType: '/heating-type', // previously: /start/5
  HeatingSources: '/heating-sources',

  InputEMailAddress: '/email-data', // previously: /start/mail
  LoadingOffer: '/generate-offer', // previously: /generateOffer
  Offer: '/offerpage', // previously: /offer

  ContactDetails: '/contact-data', // previously: /contract/1
  InvoiceAddress: '/customer', // previously: /contract/2
  HouseAddress: '/property', // previously: /contract/3
  BillingPeriod: '/billing-period',

  Summary: '/summary', // previously: /order
  OfferExpired: '/offer-expired',
  ConfirmEmail: '/confirm-e-mail', // previously: /confirmEmail
  EMailConfirmed: '/e-mail-confirmed', // previously: /emailConfirmed
  End: '/end',

  // Footer
  TOS: '/agb',
  ReturnPolicy: '/widerruf',
  DataProtection: '/datenschutz',
  CookieConsent: '/cookie-consent'
};

export const pathOfFirstStepOfFlow = paths.ApartmentCount;

export const LandingPage = () => {
  window.location.href = environmentService.getLandingPageUrl();
  return null;
};

export const isValidPath = (pathname: string) => {
  return (
    Object.entries(paths)
      .map((entry) => entry[1])
      .indexOf(pathname) >= 0
  );
};
